// extracted by mini-css-extract-plugin
export default {"userId":"UserSelectV3_userId__By1Pe","userType":"UserSelectV3_userType__Y-YOJ"};